export enum FilterState {
  All,
  Active,
  Inactive
}

export enum TelemetryFilterState {
  All,
  NoData,
  NoDataIn24Hours,
  NoDataIn3Days,
  NoDataIn1Week,
  HaveDataIn24Hours,
  HaveDataIn3Days,
  HaveDataIn1Week,
  HaveDataIn30Days
}
